import { createFileRoute, Outlet } from "@tanstack/react-router";
import { IntercomProvider } from "react-use-intercom";

import { env } from "@/env";
import { isImpersonationFrame } from "@/features/shared/impersonation";
import {
  handleSupportChatUnreadCount,
  SupportChatBubble,
} from "@/features/shared/support-chat";
import { AnalyticsProvider } from "@/libs/analytics";
import { createAnalyticsConfig } from "@/libs/analytics/config";

export const Route = createFileRoute("/(member)")({
  component: RouteComponent,
});

function RouteComponent() {
  // An admin browsing as a customer inside the impersonation frame must not
  // generate that customer's page views or events, so no provider is wired.
  const allowedProviders: ("mixpanel" | "gtm")[] = isImpersonationFrame()
    ? []
    : ["mixpanel", "gtm"];

  const appId = env.PUBLIC_INTERCOM_APP_ID || "";

  return (
    <AnalyticsProvider config={createAnalyticsConfig({ allowedProviders })}>
      {/* The vendor registers `onUnreadCountChange` inside its first boot and
          never re-registers it, so the handler must be a stable module-level
          function — see `support-chat-store`. */}
      <IntercomProvider
        appId={appId}
        onUnreadCountChange={handleSupportChatUnreadCount}
      >
        <Outlet />
        {/* Without an app id the vendor never defines its global, so a booted
            session would be a lie and the bubble would do nothing when tapped.
            Local dev has no id configured. */}
        {appId && <SupportChatBubble />}
      </IntercomProvider>
    </AnalyticsProvider>
  );
}
